export default __webpack_public_path__ + "static/media/image 5.8ca8f3df.png";